/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(9 7)" _stroke="#00272E"><g transform="rotate(-180 7 9.5)"><path pid="0" d="M5.61 14.894H.935a.629.629 0 01-.623-.634V.95C.312.6.59.318.935.318h8.416c.344 0 .623.284.623.634v9.506L5.61 14.894z"/><path pid="1" d="M5.61 14.894V11.09c0-.35.28-.634.624-.634h3.74"/></g><g transform="rotate(-180 5.143 7.605)"><path pid="2" d="M5.61 14.894H.935a.629.629 0 01-.623-.634V.95C.312.6.59.318.935.318h8.416c.344 0 .623.284.623.634v9.506L5.61 14.894z" _fill="#FFF"/><path pid="3" d="M5.61 14.894V11.09c0-.35.28-.634.624-.634h3.74"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/copy.js